<div class="p-3 mt-1">
  <!-- Title Header -->
  <div  class="p-3 rounded-lg mt-3 ">
    <div class="table-responsive text-xxs ">
      <table class="table table-hover" id="document_management_table">
        <thead class="custom-header">
          <tr>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">NO</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Document Name</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Section Name</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Date Uploaded</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Status</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in table_safe_documents" :key="index">
            <td class="text-xxs text-start">{{ index + 1 }}</td>
            <td class="text-xxs text-start">{{ row.file_name }}</td>
            <td class="text-xxs text-start">{{ row.section }}</td>
            <td class="text-xxs text-start">{{ format_date(row.submitted_on) }}</td>
            <td class="text-xxs text-start">
                <span v-if="row.is_verified" class="status-badge bg-success text-white text-xxs">Verified</span>
                <span v-else class="status-badge bg-danger text-white text-xxs">Pending Verification</span>
            </td>
            <td class="text-xxs text-start">
            <button class="btn btn-primary-dark btn-sm text-xxs shadow me-1"
                    @click="preview_file(row.presigned_url)">
                Preview
            </button>
            <button v-if="!row.is_verified"
                    class="btn btn-secondary-dark btn-sm text-xxs shadow d-none"
                    @click="verify_document(row)">
                Verify
            </button>
            </td>

          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>




<div v-if="preview_modal"  @click.self="preview_modal = false">
  <FilePreviewComponent
    :presigned_url="preview_url"
    @close="close_the_file_preview"
    :key="preview_url"
  />
</div>
